import { ObjectOps } from '../lift';
import { remove } from './remove';
// Fake function body just to get TSDoc on augmented interface :(
/**
 * Removes a key/value from this homogeneous key/value object.
 * To remove a (nullable) key from an object while preserving its type, use "update()" instead.
 * To remove a key from an object and create a new type, use "remove()"
 */
export function dissoc(key) {
    return {};
}
ObjectOps.prototype.dissoc = remove;
